<template>
  <a-modal
    v-model="showModal"
    title="Add user"
    :footer="null"
    width="600px"
    :destroyOnClose="true"
    class="add-user-modal"
  >
    <a-form-model class="" ref="addUserForm" :model="form">
      <a-row class="d-flex">
        <div class="fields-container">
          <a-form-model-item
            label="Login"
            required
            prop="login"
            :colon="false"
            :rules="[{ required: true, message: 'Login is required', trigger: ['blur', 'change'] }]"
          >
            <a-input
              v-model="form.login"
              placeholder="Login"
              size="large"
              :disabled="loading"
            />
          </a-form-model-item>
          <a-form-model-item label="Phone number" prop="phone" :colon="false">
            <a-input
              v-model="form.phone"
              placeholder="+7 (___) ___-__-__"
              size="large"
              :maxLength="18"
              :disabled="loading"
              @focus="onFocusPhoneInput"
              @blur="onBlurPhoneInput"
              @input="onPhoneInput"
              @keydown="onPhoneKeydown"
            />
            </a-form-model-item>
        </div>
      </a-row>
      <a-row class="footer-viewscreen footer">
        <div class="d-flex justify-content-end w-full">
          <a-button
            :loading="loading"
            @click="closeModal"
          >
            Cancel
          </a-button>
          <a-button
            type="primary"
            class="ml-2"
            :loading="loading"
            @click="onSubmit"
          >
            Save
          </a-button>
        </div>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { addSingleMember } from '@/views/apps/referral-program/referral-programs/members/composables/useAddMember.js'
import { subscribe, unsubscribe } from '@/composables/keydownEvent.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: [Number, null],
      default: null,
    },
    roleSystemName: {
      type: String,
      default: 'affiliate',
    },
  },
  components: {
  },
  data: () => ({
    form: {
      login: '',
      phone: '',
    },
    showModal: false,
    loading: false,
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  methods: {
    onFocusPhoneInput() {
      if (this.form.phone?.length) {
        return
      }
      this.form.phone = '+7'
    },
    onBlurPhoneInput() {
      if (this.form.phone !== '+7') {
        return
      }
      this.form.phone = ''
    },
    formatPhone(value) {
      let result = '+7'

      if (value.length > 0) result += ' (' + value.slice(0, 3)
      if (value.length >= 3) result += ') ' + value.slice(3, 6)
      if (value.length >= 6) result += ' ' + value.slice(6, 8)
      if (value.length >= 8) result += ' ' + value.slice(8, 10)

      return result
    },
    onPhoneInput(e) {
      let digits = e.target.value.replace(/\D/g, '')

      if (digits.startsWith('7')) {
        digits = digits.slice(1)
      }

      digits = digits.slice(0, 10)

      this.form.phone = this.formatPhone(digits)
    },
    onPhoneKeydown(e) {
      if (e.key !== 'Backspace') {
        return
      }

      if (this.form.phone.length <= 3) {
        e.preventDefault()
      }

      if (this.form.phone.endsWith(' ') || this.form.phone.endsWith(')') || this.form.phone.endsWith('(')) {
        e.preventDefault()
        this.form.phone = this.form.phone.slice(0, -1)
      }
    },
    normalizePhone(phone) {
      if (!phone) {
        return ''
      }

      return phone.replace(/\D/g, '')
    },
    onSubmit() {
      this.$refs.addUserForm.validate(async (valid) => {
        if (valid) {
          this.addSingle()
        } else {
          return false
        }
      })
    },
    async addSingle() {
      const programId = this.$route.params.id
      const payload = {
        login: this.form.login,
        parent_id: this.parentId,
      }
      if (this.form.phone) {
        payload.phone = this.normalizePhone(this.form.phone)
      }

      const data = await addSingleMember(this, programId, this.roleSystemName, payload)
      if (data) {
        this.$notification.success({
          message: 'User successfully added',
        })
        this.$emit('updateTable', data)
        this.closeModal()
      }
    },
    closeModal() {
      this.$emit('close')
      setTimeout(() => {
        this.form.login = ''
        this.form.phone = ''
      }, 500)
    },
  },
  mounted() {
    subscribe(this.onSubmit)
  },
  beforeDestroy() {
    unsubscribe()
  },
}
</script>

<style lang="scss">
.add-user-modal {
  .fields-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    & > div {
      flex: 1 1 auto;
      min-width: 200px;
    }
  }

  .ant-input-number {
    width: 100%;
  }

  .ant-input-number-handler-wrap {
    display: none !important;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
